import React from 'react'
import styled from 'styled-components'
import { Col, Container, Row, CardDeck, Card, CardBody, CardTitle, CardText, CardFooter } from 'reactstrap'
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl'
import { Link } from 'react-router-dom'

import TitleBar from '../../atoms/TitleBar'

import { FaGlobeAmericas } from 'react-icons/fa'
import checklistIcon from '../../organisms/Header/images/checklist-icon.png'
// logos
import chalmersLogo from './images/chalmers_logo.png'
import escolhasLogo from './images/escolhas_logo.png'
import gppLogo from './images/gpp_logo.png'
import fapespLogo from './images/fapesp_logo.png'
import geolabLogo from './images/geolab_logo.png'
import imafloraLogo from './images/imaflora_logo.png'
import ipamLogo from './images/ipam_logo.png'
import kthLogo from './images/kth_logo.png'
import noradLogo from './images/norad_logo.png'
import ocfLogo from './images/ocf_logo.png'
import seiLogo from './images/sei_logo.png'
import traseLogo from './images/trase_logo.png'
import mapbiomasLogo from './images/mapbiomas_logo.png'
import lagesaLogo from './images/lagesa_logo.png'
import ics_logo from './images/ics_logo.png'

import tradeLogo from './images/trade_logo.png'

import servirAmazoniaLogo from './images/servir_amazonia_logo_h.png'
// import Card from '../../atoms/Card'

import Button from '../../atoms/Button'
import backgroundImage from './images/btn-mapa.jpg';

const ContainerStatic = styled(Container)`
  @media only screen and (min-width: 992px) {
    margin-top: 6rem;
    padding-bottom: 6rem;
  }
`
const CustomDeck = styled(CardDeck)`
  margin-bottom: 20px;
  display: flex;
  text-decoration: none;
  margin-right: 0;
`

const CustomCardTitle = styled(CardTitle)`
  font-weight: bold;
  color: #FFFFFF!important;
  position: relative;
  margin-bottom: 30px;
`

const PageTitle = styled.div`
  font-weight: bold;
  font-size: 18px;
  margin-bottom:2rem;
  color: #32A097;
  padding-left: 75px;
  position: relative;

  @media only screen and (max-width: 992px) {
    padding-left: 3px;
  }
`

const PageHighlight = styled.h1`
  color: #555959;
  font-weight: bold;
  padding-left: 75px;
  position: relative;
  max-width:400px;

  @media only screen and (max-width: 992px) {
    padding-left: 3px;
  }
`
const CustomCardMap = styled(Card)`
  background-image: url(${backgroundImage});
  background-size: cover;
  background-position: center;
  border-radius: 0 32px 32px 0!important;
  flex-direction: column;
  overflow: auto;
  padding: 10px;
  align-items: center;
  height: 280px;
  padding-left: 50px;
  padding-right: 50px;  
  position: relative;
  overflow-y: hidden;
  
  @media only screen and (max-width: 992px) {
    border-radius: 16px!important;
    height: 350px;
    padding-left: 20px;
    padding-right: 10px;  
    br {
      display: none;
    }
  @media only screen and (max-width: 767px) {
      height: auto;
   }
 }
`
const CustomCard = styled(Card)`
  background-color: ${props => props.inputColor || '#EEEEEE'}!important;
  border-radius: 32px 0 0 32px!important;
  flex-direction: column;
  overflow: auto;
  padding: 10px;
  align-items: center;
  display: flex;
  justify-content: center;
  height: 280px;
  overflow-y: hidden;
 

  @media only screen and (max-width: 992px) {
     border-radius: 16px!important;
     height: 350px;
  }
  @media only screen and (max-width: 767px) {
    height: auto;
 }
`

const ColMarginBottom = styled(Col)`
  @media only screen and (max-width: 992px) {
    margin-bottom:8rem;
  }
`
const Partners = styled.div`
  color: #32A097;
  font-size: 24px;
`

const ImgIconContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center; 
  height: 100%; 
`

const ImgIconWrapper = styled.div`
  flex-basis: calc(100% / 5);
  text-align: center;
  margin-bottom: 10px;
  margin: auto;
  
  @media only screen and (max-width: 767px) {
    padding-bottom: 2rem;
  }
`

const ImgIconImage = styled.img`
  height: auto;
`

const PaddedRow = styled(Row)`
  padding-left: 10%;
  padding-right: 10%;

  @media only screen and (max-width: 767px) {
    padding-left: 0%;
    padding-right: 0%;
  }
`
const PaddedRowSupport = styled(Row)`
  padding-left: 20%;
  padding-right: 20%;
  
  @media only screen and (max-width: 767px) {
    padding-left: 0%;
    padding-right: 0%;
  }
`
const StyledButton = styled(Button)`
  background-color: #01c1af!important;
  font-size: 16px !important; 
  font-weight: bold!important; 
  display: block!important;
  margin-top: 2rem;
  margin-right: auto !important;
  margin-bottom: 0;
  margin-left: auto !important;
  width: 250px;
`
const VerticalLine = styled.div`
  position: absolute;
  top: 30px;
  left: 35px;
  bottom: 0;
  width: 4px;
  background-color: #01c1af;
  border-radius: 32px;
  height: 110px;
  
  @media only screen and (max-width: 992px) {
    left: 15px;
  }
`
const VerticalLineTitle = styled.div`
  position: absolute;
  top: 0px;
  left: 35px;
  bottom: 0;
  width: 4px;
  background-color: #01c1af;
  border-radius: 32px;
  
  @media only screen and (max-width: 992px) {
    left: -5px;
  }
`
const CustomCardBody = styled(CardBody)`
  padding-left: 30px;
`
const ColWithPadding = styled(Col)`
    padding-left: 45px!important;

    @media only screen and (max-width: 767px) {
      padding: 0 20px!important;
      margin: 3rem 0;
    }
`
const CustomCardLink = styled(Link)`
  display: flex;
  justify-content: center;
`
const DivBg = styled.div`
  width:100%;
  @media only screen and (min-width: 992px) {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
  }
`
const AboutUs = () =>
  <ContainerStatic>
    <Row className='pt-2 mt-3'>
      <Col xs="12" md="6">
        <PageTitle>
          <VerticalLineTitle />
          <FormattedMessage id="menu.about" />
        </PageTitle>
        <PageHighlight>
          <FormattedMessage id="home.title" />
        </PageHighlight>
      </Col>
      <ColWithPadding xs="12" md="6">
        <FormattedHTMLMessage id="about.content" />
      </ColWithPadding>
      <Col xs="12" md="6" className="mt-md-4">
        <CustomDeck>
          <CustomCardMap inputColor='#32A097'>
            <VerticalLine />
            <CustomCardBody>
              <CustomCardTitle>
                <FormattedMessage id="menu.map" />
              </CustomCardTitle>
              <FormattedMessage id="home.mapcard" />
            </CustomCardBody>
            <CustomCardLink exact to="/mapa">
              <StyledButton target="_blank" rel="noopener noreferrer">
                home.map.button
              </StyledButton>
            </CustomCardLink>
          </CustomCardMap>
        </CustomDeck>
      </Col>
      <Col xs="12" md="6" className="mt-md-4">
        <CustomDeck>
          <CustomCard inputColor='#32A097'>
            <CardBody>
              <CustomCardTitle>
                <FormattedMessage id="menu.survey" />
              </CustomCardTitle>
              <FormattedMessage id="home.surveycard" />
            </CardBody>
            <CustomCardLink exact to="/pesquisa-agropecuaria">
              <StyledButton target="_blank" rel="noopener noreferrer">
                home.statistics.button
              </StyledButton>
            </CustomCardLink>
          </CustomCard>
        </CustomDeck>
      </Col>
    </Row>
    <PaddedRow className='pt-2 mt-md-4'>
      <Col xs='12' md='12' className='text-center'>
        <Partners>
          <b><FormattedMessage id="about.partners" /></b>
        </Partners>
        <ImgIconContainer>
          <ImgIconWrapper>
            <ImgIconImage src={kthLogo} alt='kth' />
          </ImgIconWrapper>
          <ImgIconWrapper>
            <ImgIconImage src={seiLogo} alt='sei' />
          </ImgIconWrapper>
          <ImgIconWrapper>
            <ImgIconImage src={traseLogo} alt='trase' />
          </ImgIconWrapper>
          <ImgIconWrapper>
            <ImgIconImage src={servirAmazoniaLogo} alt='servir amazonia' />
          </ImgIconWrapper>
          <ImgIconWrapper>
            <ImgIconImage src={escolhasLogo} alt='escolhas' />
          </ImgIconWrapper>
        </ImgIconContainer>
      </Col>
    </PaddedRow>
    <Row className='pt-4 mt-md-4 justify-content-center'>
      <Col xs='12' md='12' className='text-center'>
        <ImgIconContainer>
          <ImgIconWrapper>
            <ImgIconImage src={chalmersLogo} alt='chalmers' />
          </ImgIconWrapper>
          <ImgIconWrapper>
            <ImgIconImage src={mapbiomasLogo} alt='mapbiomas' />
          </ImgIconWrapper>
          <ImgIconWrapper>
            <ImgIconImage src={lagesaLogo} alt='lagesa' />
          </ImgIconWrapper>
          <ImgIconWrapper>
            <ImgIconImage src={tradeLogo} alt='trade, development and environment hub' />
          </ImgIconWrapper>
          <ImgIconWrapper>
            <ImgIconImage src={gppLogo} alt='GPP - Grupo de Políticas Públicas - USP/ESALQ' />
          </ImgIconWrapper>          
        </ImgIconContainer>
      </Col>
    </Row>
    <PaddedRowSupport className='pt-2 mt-md-4'>
      <Col xs='12' md='12' className='text-center mt-4 mt-md-5'>
        <Partners>
          <b><FormattedMessage id="about.support" /></b>
        </Partners>
        <ImgIconContainer>
          <ImgIconWrapper>
            <ImgIconImage src={ics_logo} alt='ICS - Instituto Clima e Sociedade' />
          </ImgIconWrapper>
        </ImgIconContainer>
      </Col>
    </PaddedRowSupport>
    <Row className='pt-4 mt-md-4 justify-content-center'>
      <ColMarginBottom xs='12' md='6' className='text-center mb-md-4'>
        <ImgIconContainer>
        <ImgIconWrapper>
            <ImgIconImage src={fapespLogo} alt='fapesp' />
          </ImgIconWrapper>
          <ImgIconWrapper>
            <ImgIconImage src={noradLogo} alt='norad' />
          </ImgIconWrapper>
          <ImgIconWrapper>
            <ImgIconImage src={ocfLogo} alt='ocf' />
          </ImgIconWrapper>        
          <ImgIconWrapper>
            <ImgIconImage src={ipamLogo} alt='ipam' />
          </ImgIconWrapper>
        </ImgIconContainer>
      </ColMarginBottom >
    </Row>
  </ContainerStatic>

export default AboutUs



// WEBPACK FOOTER //
// ./src/components/templates/AboutUs/AboutUs.js